import { useEffect } from "react";

import ReportsTable from "../../components/reports/ReportsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useReports from "../../data/useReports";

export default function Reports() {
  const { setInfo } = usePageNameContext();
  const { reports } = useReports();

  useEffect(() => {
    setInfo({
      name: `Reports`,
      desc: `View and download reports`,
    });
  }, [setInfo]);

  if (reports.isLoading) {
    return <LoadingWheel />;
  }

  return (
    <ReportsTable data={reports.data?.data || []} />
  );
}